import { render, staticRenderFns } from "./GrievanceItemActions.vue?vue&type=template&id=4321021b&scoped=true&"
import script from "./GrievanceItemActions.vue?vue&type=script&lang=ts&"
export * from "./GrievanceItemActions.vue?vue&type=script&lang=ts&"
import style0 from "./GrievanceItemActions.vue?vue&type=style&index=0&id=4321021b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4321021b",
  null
  
)

/* custom blocks */
import block0 from "./GrievanceItemActions.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports